<h2><span style="color: #3376f6">Questions</span> fréquentes</h2>
<p>
  N’hésitez pas à prendre contact avec votre conseiller pour toute question
  complémentaires
</p>
<br />
<div
  class="questions"
  #questions
  [style.grid-template-columns]="
    questions.children.length % 2 != 1
      ? 'grid-template-columns: repeat(1, 1fr)'
      : 'inherit'
  "
>
  <ng-content></ng-content>
</div>
